export const PLACEMENTS_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "Placement Partner",
    meta_status: true,
  },

  PLACEMENTS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Placements Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Placements Title",
      required: false,
      defaultValue: "Our Placement Partners",
    },
    {
      fieldName: "title_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "scroll_frequency",
      label: "Scroll Frequency",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Scroll Frequency",
      required: false,
      defaultValue: 0,
    },
    {
      fieldName: "status",
      label: "Placements Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Placements Status",
      defaultValue: false,
    }
  ],

  METADATA_FIELDS: [
    {
      header: "Image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Image",
    },
    {
      header: "Alt Image",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Status",
    },
  ]
};

